<header class="component-content-header p-3">
    <h1 class="main-title mb-0">Installation Script</h1>
</header>
<div class="component-content-inner p-3" *ngIf="widgetId$ | async as widgetId">
    <nirby-widget-script [widgetId]="widgetId"></nirby-widget-script>
</div>
